import React from "react";
import Navbar from "../../Navbar/Navbar";
import ModelAuditLog from "./ModelAuditLog";
import FillDetailAuditLog from "./FillDetailAuditLog";
import ScroollTableAuditLog from "./ScroollTableAuditLog";
import { ProductConsumer } from "../../Context/AddProWakel";

class AllAuditLogPage extends React.Component {
    render() {
        return (
            <div>
                <Navbar />
                <ProductConsumer>
                    {(value) => {
                        return <AuditLogBody value={value} />;
                    }}
                </ProductConsumer>
                <ModelAuditLog />
            </div>
        );
    }
}

class AuditLogBody extends React.Component {
    componentDidMount() {
        this.props.value.AL_getLogs();
    }

    render() {
        return (
            <div style={{ marginTop: "50px" }}>
                <div className="row" style={{ backgroundColor: "#2C3539" }}>
                    <div className="col-12">
                        <FillDetailAuditLog />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <ScroollTableAuditLog />
                    </div>
                </div>
            </div>
        );
    }
}

export default AllAuditLogPage;
